import store from '@/store';
export default class RefreshAgentConfFileDataEvent {
  constructor(body) {
    const agentAckCall = body.agentConfFile.ackCall;
    store.dispatch('attendance/updateAckCallRequest', agentAckCall);
  }
}
